module.exports = __webpack_public_path__ + "img/mass-whatsapp.9ccd1a23.png";